import { API_URL } from "./Config";
import { PageResult } from "./Pagination";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync } from "./LicenceDetails";
import { formatDate } from "./DateUtils";
import { eventTupleToStore } from "@fullcalendar/react";

export interface ISubmissionRow {
  submissionid: string;
  licenceid: string;
  licenceprofileid: string;
  licenceapplicationid: string;
  casenumber: string;
  createdon: string;
  type: string;
  objectortype: string;
  submitter: string;
  receiveddate: string;
  oralhearingrequested: boolean;
}

export interface ISubmissionDetails extends IDetailsResponse {
  submissionid: string;
  licenceid: string;
  licenceprofileid: string;
  licenceapplicationid: string;
  casenumber: string;
  createdon: string;
  type: string;
  objectortype: string;
  submitter: string;
  receiveddate: string;
  oralhearingrequested: boolean;
  licence_regno: string;
}

export interface ISubmissionsList extends PageResult {
  list: ISubmissionRow[];
}

export const GetSubmissionsByLicenceFetchUrl = (
  licence_id: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      params += `&${filterId}=${f.value}`;
    }
  }

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/Submission/filteredlistbylicence?licence_id=${licence_id}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/submissions-list`;
  }

  return url;
};

export interface ISubmissionsGridFilterValue {
  name: string;
  value: string;
}

export interface ISubmissionsGridFilterValueList {
  count: number;
  list: ISubmissionsGridFilterValue[];
}

export async function GetSubmissionTypesAsync(): Promise<ISubmissionsGridFilterValueList> {
  let url = `${API_URL}/Submission/sumbissiontypefilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/submissions-types`;
  }

  var response = await fetch(url);
  var body = <ISubmissionsGridFilterValueList>await response.json();
  body.list = body.list.map((item) => {
    return <ISubmissionsGridFilterValue>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export async function GetSubmissionObjectorTypesAsync(): Promise<ISubmissionsGridFilterValueList> {
  let url = `${API_URL}/Submission/sumbissionobjectortypefilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/submissions-objector-types`;
  }

  var response = await fetch(url);
  var body = <ISubmissionsGridFilterValueList>await response.json();
  body.list = body.list.map((item) => {
    return <ISubmissionsGridFilterValue>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export const SubmissionOrObjection = (type: string) => {
  if (type.toUpperCase() === "SUBMISSION") return "Submission";
  else return "Objection";
};

export const SubmitterOrObjector = (type: string) => {
  if (type.toUpperCase() === "SUBMISSION") return "Submitter";
  else return "Objector";
};

export const OralHearingValue = (type: boolean): string => {
  if (type === true) return "Yes";
  else if (type === false) return "No";
  else return "N/A";
};

export async function GetSubmissionDetailsAsync(
  submissionId: string
): Promise<ISubmissionDetails> {
  var url = `${API_URL}/Submission/byid?submission_id=${submissionId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/submission-details`;
  }

  var response = await fetch(url);
  var body = <ISubmissionDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  return <ISubmissionDetails>{
    response: response,
    submissionid: body.submissionid,
    licenceid: body.licenceid,
    licenceprofileid: body.licenceprofileid,
    licenceapplicationid: body.licenceapplicationid,
    casenumber: body.casenumber,
    createdon: formatDate(body.createdon),
    type: body.type,
    objectortype: body.objectortype,
    submitter: body.submitter,
    receiveddate: formatDate(body.receiveddate),
    oralhearingrequested: body.oralhearingrequested,
    licence_regno: licenceDetails.reg_no,
  };
}
